import { createApiClient } from "@/utils/api";
import { AuthService } from "@/gen/api/v1/auth_pb";
import type { LoginRequest, RegisterRequest } from "@/gen/api/v1/auth_pb";

const client = createApiClient(AuthService);

type LoginResponse = Awaited<ReturnType<typeof client.login>>;
type RegisterResponse = Awaited<ReturnType<typeof client.register>>;

export const authService = {
  login: (request: LoginRequest): Promise<LoginResponse> => {
    return client.login(request);
  },

  register: (request: RegisterRequest): Promise<RegisterResponse> => {
    return client.register(request);
  },
};

export type { LoginRequest, RegisterRequest };
